import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-zone',
  templateUrl: './about-zone.component.html',
  styleUrls: ['./about-zone.component.scss']
})
export class AboutZoneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
